import runOnDomReady from './main-ondomready.js';
import runOnLoad from './main-onload.js';
import CvValidatorRule from '../../common/js/CvValidatorRule';
import SwitchTabs from '../../common/js/SwitchTabs';
import { executeOnDocumentReady } from '../../../utils';

CvValidatorRule();
SwitchTabs('.ai-selector');
executeOnDocumentReady(runOnDomReady);

// on load
window.addEventListener('load', runOnLoad, { once: true });
